import { createStore, combineReducers } from 'redux';
import { AuthState } from 'types/authType';
import ui, { UiState } from './ui';
import customerMaster, { CustomerMasterStateType } from './customerMaster';
import reservationBookingOnline, { ReservationBookingOnlineType } from './reservationBooking';
import mailMagazineDetail, { MailMagazineCreateEditType } from './mailMagazine';
import approvalDocumentMasterRegistration, { InitialApprovalDocMasterRegisSettingType } from './ApprovalDocumentMasterRegistration';
import auth from './auth';
import approvalAmountDoc, { InitialApprovalDocMasterAmount } from './approvalAmountDoc';
import approvalDocumentAdvancedSearch, { ApprovalDocumentAdvancedSearchType } from './approvalDocumentAdvancedSearch';
import reApplyDocument, { InitialReApplyDocument } from './reApplyDocuments';
import reservationInquiryAmount, { InitialReservationInquiryAmount } from './reservationInquiryAmount';

export interface Store {
    ui: UiState;
    auth: AuthState;
    customerMaster: CustomerMasterStateType;
    mailMagazineDetail:MailMagazineCreateEditType,
    reservationBookingOnline:ReservationBookingOnlineType,
    approvalDocumentMasterRegistration: InitialApprovalDocMasterRegisSettingType;
    approvalAmountDoc: InitialApprovalDocMasterAmount;
    approvalDocumentAdvancedSearch: ApprovalDocumentAdvancedSearchType;
    reApplyDocument: InitialReApplyDocument;
    reservationInquiryAmount: InitialReservationInquiryAmount;
}

export default createStore(combineReducers<Store>({
  ui, auth, customerMaster, mailMagazineDetail, reservationBookingOnline, approvalDocumentMasterRegistration, approvalAmountDoc, approvalDocumentAdvancedSearch, reApplyDocument, reservationInquiryAmount,
}));
